<template>
  <Card>
    <template #title>
      <div class="p-d-flex p-justify-between">
        <div>{{ title }}</div>
        <div>
          <Button label="บันทึก" icon="pi pi-save" @click="onSave"></Button
          ><Button
            label="ย้อนกลับ"
            class="p-button-warning p-ml-2"
            icon="pi pi-chevron-left"
            @click="onBack"
          ></Button>
        </div>
      </div>
    </template>
    <template #content>
      <div class="p-grid">
        <div class="p-col-12 p-md-3 p-fluid p-field">
          <span class="p-float-label"
            ><InputText
              id="questionId"
              v-model="question.id"
              readonly
            ></InputText
            ><label for="questionId">รหัส</label></span
          >
        </div>
        <div class="p-col-12 p-md-6 p-fluid p-field">
          <span class="p-float-label">
            <InputText id="name" v-model="question.name"></InputText>
            <label for="name">ชื่อแบบประเมิน</label>
          </span>
          <small class="p-error" v-if="v$.question.name.$error">{{
            v$.question.name.required.$message
          }}</small>
        </div>
        <div class="p-col-12 p-md-3 p-fluid p-field">
          <span class="p-float-label">
            <InputText id="iso" v-model="question.isoDocumentNo"></InputText>
            <label for="iso">เลขที่เอกสารในระบบ ISO 9001</label>
          </span>
        </div>
        <div class="p-col-12 p-fluid p-field">
          <span class="p-float-label">
            <InputText id="title" v-model="question.title"> </InputText>
            <label for="title">Title ใน Form ของแบบประเมิน</label>
          </span>
          <small class="p-error" v-if="v$.question.title.$error">{{
            v$.question.title.required.$message
          }}</small>
        </div>
        <div class="p-col-12">
          <div class="p-d-flex p-justify-end">
            <Button
              label="เพิ่มรายการใหม่"
              icon="pi pi-plus"
              @click="onNewQuestionItem"
            ></Button>
            <Button
              label="ทดสอบ"
              class="p-ml-2"
              icon="pi pi-eye"
              @click="onShowPopup"
            ></Button>
          </div>
        </div>

        <div class="p-col-12">
          <DataTable :value="items" class="p-datatable-sm" dataKey="item">
            <template #footer=""
              >แบบประเมินทั้งหมด {{ items.length }} ข้อ</template
            >
            <template #empty="">ไม่มีข้อมูล กรุณาเพิ่มคำถามก่อน</template>
            <Column header="Section">
              <template #body="props">
                <div class="p-fluid">
                  <Textarea
                    v-model="props.data.section"
                    :class="{ 'p-invalid': !props.data.section }"
                  ></Textarea>
                  <small v-if="!props.data.section" class="p-error">
                    กรุณาระบุข้อความ
                  </small>
                </div>
              </template>
            </Column>
            <Column header="Question">
              <template #body="props">
                <div class="p-fluid">
                  <div class="p-grid">
                    <div class="p-col-12">
                      <Textarea
                        v-model="props.data.question"
                        :class="{ 'p-invalid': !props.data.question }"
                      >
                        <small v-if="!props.data.question" class="p-error">
                          กรุณาระบุข้อความ
                        </small>
                      </Textarea>
                    </div>
                    <div
                      class="p-col-12"
                      v-if="props.data.type === QuestionItemType.choice"
                    >
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          ก.
                        </span>
                        <InputText v-model="props.data.choice1"></InputText>
                      </div>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          ข.
                        </span>
                        <InputText v-model="props.data.choice2"></InputText>
                      </div>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          ค.
                        </span>
                        <InputText v-model="props.data.choice3"></InputText>
                      </div>
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          ง.
                        </span>
                        <InputText v-model="props.data.choice4"></InputText>
                      </div>
                    </div>
                    <div
                      class="p-col-12"
                      v-if="props.data.type === QuestionItemType.choice"
                    >
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          คำตอบที่ถูกต้อง
                        </span>
                        <Dropdown
                          :id="`correctAnswer${props.index}`"
                          optionValue="code"
                          optionLabel="description"
                          :options="[
                            { code: 1, description: 'ก.' },
                            { code: 2, description: 'ข.' },
                            { code: 3, description: 'ค.' },
                            { code: 4, description: 'ง.' },
                          ]"
                          v-model="props.data.correctAnswer"
                        >
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Column>
            <Column
              header="Type"
              headerStyle="width:13rem"
              bodyStyle="width: 13rem"
            >
              <template #body="props">
                <div class="p-fluid">
                  <Dropdown
                    v-model="props.data.type"
                    :options="questionTypes"
                    option-label="description"
                    option-value="code"
                    :class="{ 'p-invalid': !props.data.type }"
                  ></Dropdown>
                  <small v-if="!props.data.type" class="p-error">
                    กรุณาระบุประเภทคำถาม
                  </small>
                </div>
              </template>
            </Column>
            <Column
              header="Sort"
              headerStyle="width:4rem"
              bodyStyle="width: 4rem"
            >
              <template #body="props">
                <div class="p-fluid">
                  <InputNumber v-model="props.data.sort"></InputNumber>
                </div>
              </template>
            </Column>
            <Column
              header="Role"
              headerStyle="width:8rem"
              bodyStyle="width: 8rem"
            >
              <template #body="props">
                <div class="p-d-flex p-flex-column">
                  <span class="p-field-checkbox">
                    <Checkbox
                      :id="`employee${props.index}`"
                      binary
                      v-model="props.data.employee"
                    ></Checkbox>
                    <label
                      v-tooltip="`พนักงานสามารถแก้ไขได้`"
                      :for="`employee${props.index}`"
                      >พนักงาน</label
                    >
                  </span>
                  <span class="p-field-checkbox">
                    <Checkbox
                      :id="`supervisor${props.index}`"
                      binary
                      v-model="props.data.supervisor"
                    ></Checkbox>
                    <label
                      v-tooltip="`หัวหน้างานสามารถแก้ไขได้`"
                      :for="`supervisor${props.index}`"
                      >หัวหน้างาน</label
                    >
                  </span>

                  <span class="p-field-checkbox">
                    <Checkbox
                      :id="`required${props.index}`"
                      binary
                      v-model="props.data.required"
                    ></Checkbox>
                    <label
                      v-tooltip="`ต้องระบุข้อมูล`"
                      :for="`required${props.index}`"
                      >Required?</label
                    >
                  </span>

                  <span class="p-field-checkbox">
                    <Checkbox
                      :id="`finalScore${props.index}`"
                      binary
                      v-model="props.data.finalScore"
                    ></Checkbox>
                    <label
                      v-tooltip="`คะแนนที่ใช้สรุปผล`"
                      :for="`finalScore${props.index}`"
                      >Final Score</label
                    >
                  </span>
                </div>
              </template>
            </Column>

            <Column
              header="Action"
              headerStyle="width:4rem"
              bodyStyle="width: 4rem"
            >
              <template #body="props">
                <Button
                  class="p-button-rounded p-button-danger"
                  icon="pi pi-trash"
                  @click="() => onDeleteQuestionItem(props.index)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>

        <!-- <div class="p-col-2 p-text-bold">Section</div>
        <div class="p-col-4 p-text-bold">Question</div>
        <div class="p-col-2 p-text-bold">Type</div>
        <div class="p-col-1 p-text-bold">Sort</div>
        <div class="p-col-2 p-text-bold">Role</div>
        <div class="p-col-1 p-text-bold">Action</div>

        <div class="p-col-12">
          <ScrollPanel style="height: 350px">
            <div class="p-grid">
              <template
                v-for="(item, index) in items"
                :key="`question${index}`"
              >
                <div class="p-col-2 p-fluid">
                  <Textarea v-model="item.section"></Textarea>
                </div>
                <div class="p-col-4 p-fluid">
                  <Textarea v-model="item.question"></Textarea>
                </div>
                <div class="p-col-2 p-fluid">
                  <Dropdown
                    v-model="item.type"
                    :options="questionTypes"
                    option-label="description"
                    option-value="code"
                  ></Dropdown>
                </div>
                <div class="p-col-1 p-fluid">
                  <InputNumber v-model="item.sort"></InputNumber>
                </div>
                <div class="p-col-2 p-fluid">
                  <div class="p-d-flex p-flex-column">
                    <span class="p-field-checkbox">
                      <Checkbox
                        :id="`employee${index}`"
                        binary
                        v-model="item.employee"
                      ></Checkbox>
                      <label :for="`employee${index}`">พนักงาน</label>
                    </span>
                    <span class="p-field-checkbox">
                      <Checkbox
                        :id="`supervisor${index}`"
                        binary
                        v-model="item.supervisor"
                      ></Checkbox>
                      <label :for="`supervisor${index}`">หัวหน้างาน</label>
                    </span>

                    <span class="p-field-checkbox">
                      <Checkbox
                        :id="`required${index}`"
                        binary
                        v-model="item.required"
                      ></Checkbox>
                      <label :for="`required${index}`">Required?</label>
                    </span>
                  </div>
                </div>
                <div class="p-col-1">
                  <Button
                    class="p-button-rounded p-button-danger"
                    icon="pi pi-trash"
                    @click="() => onDeleteQuestionItem(index)"
                  ></Button>
                </div>
              </template>
            </div>
          </ScrollPanel>
        </div> -->
      </div>
    </template>
  </Card>

  <Dialog header="ตัวอย่างแบบประเมิน" v-model:visible="showPopup" modal>
    <QuestionPanel :questionItems="items" :testMode="true"></QuestionPanel>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  QuestionItem,
  UpsertQuestionRequest,
  Question,
  GetQuestionRequest,
  GetQuestionResponse,
  QuestionType,
  QuestionItemType,
} from "@/types";
import QuestionPanel from "@/components/QuestionPanel.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default defineComponent({
  name: "QuestionScreen",
  components: { QuestionPanel },
  setup() {
    const { onBack, setLoading, error, success, axios, route } = usePlugin();

    const newQuestion: Question = {
      id: 0,
      name: "",
      title: "",
      body: "",
      type: QuestionType.Training,
      createDate: null,
      createBy: null,
      updateDate: null,
      updateBy: null,
      createByEmployee: null,
      updateByEmployee: null,
      isoDocumentNo: "",
    };
    const question = ref<Question>(newQuestion);
    const items = ref<QuestionItem[]>([]);

    const rules = computed(() => {
      return {
        question: {
          name: { required },
          title: { required },
          type: { required },
        },
      };
    });
    const v$ = useVuelidate(rules, { question });
    const questionTypes = [
      { code: 1, description: "Text" },
      { code: 2, description: "Scale" },
      { code: 3, description: "Scale with text" },
      { code: 4, description: "Choice" },
    ];
    const showPopup = ref(false);
    const onShowPopup = () => (showPopup.value = true);
    const onNewQuestionItem = () => {
      items.value.push({ item: items.value.length } as QuestionItem);
    };
    const onDeleteQuestionItem = (index: number) => {
      items.value.splice(index, 1);
    };
    const id = computed(() =>
      route.params["id"] ? parseInt(route.params["id"] as string) : null
    );
    const title = computed(() =>
      id.value != null
        ? `แก้ไขแบบประเมิน ID ${id.value}`
        : "สร้างแบบประเมินใหม่"
    );
    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetQuestionResponse>(
          "api/v1/services/question/get",
          {
            id: id.value,
            searchString: "",
          } as GetQuestionRequest
        );
        question.value = result.data.questions[0];
        items.value = JSON.parse(question.value.body ?? "[]");
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSave = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) return;

      if (question.value == undefined)
        throw Error("invalid question object undefined");
      setLoading(true);
      try {
        question.value.body = JSON.stringify(items.value);
        await axios.post("api/v1/services/question/upsert", {
          question: question.value,
        } as UpsertQuestionRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      if (id.value != null) {
        loadDocument();
      } else {
        items.value = [];
      }
    });
    return {
      items,
      onBack,
      onNewQuestionItem,
      onDeleteQuestionItem,
      questionTypes,
      onSave,
      title,
      id,
      question,
      showPopup,
      onShowPopup,
      v$,
      QuestionItemType,
    };
  },
});
</script>

<style scoped></style>
